module.exports = __webpack_public_path__ + "static/media/default.b6681619.png";